import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, User } from 't4core';
import { FormControl } from '@angular/forms';
import { Observable, from } from 'rxjs';

@Component({
  selector: 't4-editUserDialog',
    templateUrl: 'editUserDialog.html',
})
export class EditUserDialog extends DialogBase {
    public user: User = null;
    public newUser: boolean = true;

    constructor(public dialogRef: MatDialogRef<EditUserDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        super("EditUserDialog");

        if (data.user) {
            this.user = data.user;
            this.newUser = false;
        }

    }

    public newUserCreated(user: any) {
        this.user = user;
        this.newUser = false;
    }
}
